<template>
  <div class="components-container">
    <div class="editor-container">
      <dnd-list :list1="list1" :list2="list2" list1-title="List" list2-title="Article pool" />
    </div>
  </div>
</template>

<script>
import DndList from '@/components/DndList'

export default {
  name: 'DndListDemo',
  components: { DndList },
  data() {
    return {
      teacherName: "",
      list: [
        {id:'1',author:"acxcassd",title:"asdasdw"},
        {id:'2',author:"acxcassd",title:"asdasdw"},
        {id:'3',author:"acxcassd",title:"asdasdw"},
        {id:'4',author:"acxcassd",title:"asdasdw"},
        {id:'5',author:"acxcassd",title:"asdasdw"},
        {id:'6',author:"acxcassd",title:"asdasdw"},
        {id:'7',author:"acxcassd",title:"asdasdw"},
        {id:'8',author:"acxcassd",title:"asdasdw"},
        {id:'9',author:"acxcassd",title:"asdasdw"},
        {id:'10',author:"acxcassd",title:"asdasdw"},
        {id:'11',author:"acxcassd",title:"asdasdw"},
        {id:'12',author:"acxcassd",title:"asdasdw"},
        {id:'13',author:"acxcassd",title:"asdasdw"},
        {id:'14',author:"acxcassd",title:"asdasdw"},
        {id:'15',author:"acxcassd",title:"asdasdw"},
        {id:'16',author:"acxcassd",title:"asdasdw"},
        {id:'17',author:"acxcassd",title:"asdasdw"},
        {id:'18',author:"acxcassd",title:"asdasdw"},
        {id:'19',author:"acxcassd",title:"asdasdw"},
      ],
      list1: [],
      list2: [],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.listLoading = true
      this.list1 = this.list.splice(0, 5);
      this.list2 = this.list
    }
  }
}
</script>

